import(/* webpackMode: "eager", webpackExports: ["ContainerComponent"] */ "/usr/share/nginx/html/pwatools/core/general/container/container.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/usr/share/nginx/html/pwatools/node_modules/next/dist/client/app-dir/link.js");
